import { createSlice } from '@reduxjs/toolkit'
import moment from 'moment'
const initialState = {
    stage: 0,
    customer: null,
    period_start_time: moment(Date.now()).format('YYYY-MM-DD'),
    period_end_time: moment(Date.now()).format('YYYY-MM-DD'),
    effective_time: moment(Date.now()).format('YYYY-MM-DD'),
    lastPaymentDate: moment(Date.now()).format('YYYY-MM-DD'),
    bank: null,
    invoiceIds: [],
    selectedInvoices: [],
    invoicesData: '',
    ciproducts: [],
    type: 0,
    code: '',
    note: '',
    amount: 0,
    gallon: 0,
    vat: 0,
    mt: 0,
    total: 0,
    lit: 0,
    kg: 0,
    selectedCurrency: null,
}
export const commercialInvoiceSlice = createSlice({
  name: 'New Commercial invoice',
  initialState,
  reducers: {
     // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
    setStage: (state, action) => {
        state.stage = action.payload
    },
    setEffectiveDate: (state, action) => {
        state.effective_time = action.payload
    },
    setLastPaymentDate: (state, action) => {
        state.lastPaymentDate = action.payload
    },
    setSelectedBank: (state, action) => {
        state.bank = action.payload
    },
    setStartTime: (state, action) => {
        state.period_start_time = action.payload
    },
    setEndTime: (state, action) => {
        state.period_end_time = action.payload
    },
    setCustomer: (state, action) => {
        state.customer = action.payload
    },
    setSelectedInvoices: (state, action) => {
        state.invoiceIds = action.payload 
    },
    setAdvanceOption: (state, action) => {
        state.type = action.payload 
    },
    setInvoicess: (state, action) => {
        state.invoices = action.payload
    },
    setCIProduct: (state, action) => {
        state.ciproducts = action.payload
    },
    updateCIProduct: (state, action) => {       //update ciproduct,  nhan 3 tham so lan luot la index: index trong array, key: ten key cua object can update, value: gia tri moi cua key
        state.ciproducts[action.payload.index][action.payload.key] = action.payload.value
    },
    setCode: (state, action) => {
        state.code = action.payload
    },
    setNote: (state, action) => {       //rich text
        state.note = action.payload
    },
    setCIState : (state, action) => {       // reducer viet rut gon, gop tat ca reducer thanh 1 reducer
        // state[action.payload.state] = action.payload.value
        Object.keys(action.payload).forEach(key => state[key] = action.payload[key])  //action.state la 1 object gom key la ten state can update, value la value moi
    },
    setDefaultCI: () => ({...initialState})
  },
})

// Action creators are generated for each case reducer function
export const { setCustomer, setCIState, setDefaultCI, setCode, setNote, setCIProduct, updateCIProduct, setSelectedBank, setStage, setStartTime, setInvoicess, setEndTime, setEffectiveDate, setLastPaymentDate, setSelectedInvoices, setAdvanceOption } = commercialInvoiceSlice.actions

export default commercialInvoiceSlice.reducer